import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppCard from '../../common/AppCard';
import AppFlexbox from '../../common/AppFlexbox';
import AppCheckbox from '../../common/AppCheckbox';
import * as classes from '../../../styles/nestedStyles.module.css';

const PublishResourceToServiceModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedPkServices,
  serviceList
}) => {
  const { state } = useContext(StoreContext);
  const [formState, setFormState] = useState({ pkServices: [] });

  useEffect(() => {
    if (isOpen) {
      setFormState({pkServices: selectedPkServices?.map((s) => s.toString()) || []});
    }
  }, [isOpen]);

  return (
    <ResponsiveModal
      formSectionProps={{
        onCancel: onClose,
        submitTitle: 'Confirm',
        onSubmit: () => {
          onConfirm(formState);
        }
      }}
      isLoading={false}
      isOpen={isOpen}
      onClose={onClose}
      title="Publish to sales channels"
    >
      <AppStack style={{ gap: 16 }}>
        <AppText style={{ fontSize: 14, color: '#666', textAlign: 'center' }}>
          This will make the collection live and visible to customers on the
          selected platforms.
        </AppText>

        <AppStack style={{ gap: 8 }}>
          {serviceList.map((service) => {
            const selected = formState.pkServices.includes(service.value);

            return (
              <AppCard
                key={service.value}
                className={classes['hover-action-card']}
                onClick={() => {
                  setFormState({
                    ...formState,
                    pkServices: selected
                      ? formState.pkServices.filter(
                          (type) => type !== service.value
                        )
                      : [...formState.pkServices, service.value]
                  });
                }}
                radius={8}
                shadow="xs"
                style={{ padding: 16 }}
                withBorder
              >
                <AppFlexbox style={{ alignItems: 'center' }}>
                  <AppCheckbox checked={selected} onChange={(e) => {}} />
                  <AppStack style={{ gap: 8 }}>
                    <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                      {service.label}
                    </AppText>

                    {service.singlePublish && (
                      <AppText
                        style={{
                          fontSize: 12,
                          fontStyle: 'italic',
                          color: '#666'
                        }}
                      >
                        Only one collection can be published to this service at
                        a time.
                      </AppText>
                    )}
                  </AppStack>
                </AppFlexbox>
              </AppCard>
            );
          })}
        </AppStack>
      </AppStack>
    </ResponsiveModal>
  );
};

PublishResourceToServiceModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  selectedPkServices: PropTypes.array,
  serviceList: PropTypes.array
};

export default PublishResourceToServiceModal;
